<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">人事名录</span>
              <span class="text_14">（文案占位非正式内容）新闻与传播研究所人事名录相关资料。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_lirensuolingdao" style="color: inherit; text-decoration: none;">人事名录</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">人员名录</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="personnel-directory"
                active-item-id="staff-directory"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <div class="staff-directory-panel">
                <div class="staff-directory-title">新闻与传播研究所人员名录</div>

                <section class="staff-section">
                  <h3 class="staff-section-title">在职（含聘用）人员名录</h3>
                  <div class="staff-section-body">
                    <p>所领导：赵天晓、唐绪军、李为民</p>
                    <p>综合办公室：黄双润、贾云海、吴秋玲、刘若玉、张逸、杜鑫、李振东</p>
                    <p>马克思主义新闻学研究室：黄楚新、向芬、刘志明、王颖、叶俊</p>
                    <p>传播学研究室：张丹、王凤翔、季芳芳、曾国华、孙萍</p>
                    <p>媒介研究室：殷乐、冷松、张放、张建珍、曾昕</p>
                    <p>网络学研究室：孟威、张化冰、雷霞、赵康、苗伟山</p>
                    <p>信息室：杨瑞明、杨斌艳、王颖、段铁铮、牛天、李荔昭</p>
                    <p>编审室：钱莲生、宋鸿军、韩智冬、张满丽、刘瑞生、肖重斌、贾金釜、沙垚、张萌</p>
                  </div>
                </section>

                <section class="staff-section">
                  <h3 class="staff-section-title">离退休人员名录</h3>
                  <div class="staff-section-body">
                    <p>
                      张苑、陶涵、邹德真、梁明、赫建中、陈崇山、何光先、卫景福、李增义、朱丽萍、白雪、陈光君、刘玉芳、刘俊婕、邱本洁、朱向霞、徐宗辉、高希康、
                      徐耀魁、宁新、张兰华、梁博祥、孙旭瑾、马桂芝、明安香、闫大洪、张正岭、王萱、王辉、孙五三、孙京华、王怡红、蒋勇、时统宇、卜卫、刘晓红、宋小卫
                    </p>
                  </div>
                </section>

                <section class="staff-section">
                  <h3 class="staff-section-title">已去世人员名录</h3>
                  <div class="staff-section-body">
                    <p>
                      何炳然、邓济民、伍素心、饶彬、方德、张铁、夏晓林、李桂山、谢冰岩、金耀云、张黎、万蒙、钱辛波、喻权域、李斯颐、王敬、李淑秋、闫焕书、彭朝丞、孟孝礼、林毅之、闫希同、王峰英、李连斌、张钰、韩辛茹、齐振基、郑书奇
                    </p>
                  </div>
                </section>

                <section class="staff-section">
                  <h3 class="staff-section-title">曾经在所工作的人员名录</h3>
                  <div class="staff-section-body">
                    <p>包靖国（1978-1980） 范建中（1978-1988） 黄可风（1978-1985）</p>
                    <p>姜美娣（1978-1980） 李汉泉（1978-1979） 刘克良（1978-1984）</p>
                    <p>邱光欣（1978-1982） 张德勤（1978-1980） 赵炳辉（1978-1981）</p>
                    <p>王乎庆（1979-1980） 姚臻璐（1979-1984） 张光复（1979-1984）</p>
                    <p>朱云英（1979-1986） 范克（1980-1980） 陈力丹（1981-2003）</p>
                    <p>丁引芳（1981-1981） 寞其文（1981-1986） 高欢（1981-1986）</p>
                    <p>姜宇辉（1981-1984） 刘力群（1981-1992） 刘一鸣（1981-1995）</p>
                    <p>卢惠民（1981-1986） 石励军（1981-1985） 孙淑君（1981-1995）</p>
                    <p>汤广曼（1981-1984） 王凤超（1981-1988） 王庚虎（1981-1984）</p>
                    <p>王美芝（1981-1994） 曾美云（1981-1992） 张宗厚（1981-1983）</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuRenshirenyuanminglu',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'personnel-directory',
        activeItemId: 'staff-directory'
      })
    };
  }
};
</script>
<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}

.staff-directory-panel {
  background: #fff;
  border: 1px solid #ece7dd;
}

.staff-directory-title {
  background: #ce6a33;
  color: #fff;
  font-size: 24px;
  line-height: 34px;
  padding: 12px 24px;
  font-family: SourceHanSerifCN-SemiBold, 'PingFang SC', sans-serif;
}

.staff-section {
  padding: 18px 24px 4px;
}

.staff-section + .staff-section {
  padding-top: 24px;
}

.staff-section-title {
  margin: 0;
  color: #a45f19;
  font-size: 18px;
  line-height: 30px;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
  font-weight: 400;
  padding-bottom: 8px;
  border-bottom: 1px solid #be8a4a;
}

.staff-section-body {
  margin-top: 14px;
  color: #1c1c1c;
  font-size: 16px;
  line-height: 1.75;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

.staff-section-body p {
  margin: 0 0 4px;
}

@media (max-width: 1100px) {
  .staff-directory-title {
    font-size: 22px;
    line-height: 32px;
  }

  .staff-section-title {
    font-size: 17px;
    line-height: 28px;
  }
}
</style>
